import { createFileRoute } from "@tanstack/react-router";
import { ShieldCheck, UserRound } from "lucide-react";

import { useAuth } from "@/auth/AuthProvider";
import { ContaSection } from "@/components/configuracoes/ContaSection";
import { LgpdSection } from "@/components/configuracoes/LgpdSection";
import { SettingsCard } from "@/components/configuracoes/SettingsCard";

export const Route = createFileRoute("/_authed/configuracoes/conta")({
  staticData: {
    title: "Conta",
    subtitle: "Seus dados de acesso, privacidade e exclusão da conta.",
  },
  component: ContaPage,
});

function ContaPage() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="space-y-6">
      <SettingsCard
        icon={ShieldCheck}
        title="Privacidade"
        description="Exportação dos dados do estabelecimento (LGPD)."
      >
        <LgpdSection establishmentId={user.establishment_id} />
      </SettingsCard>

      {/* Conta por último: é onde mora a ação destrutiva de excluir a conta,
          longe dos botões de salvar do dia a dia. */}
      <SettingsCard icon={UserRound} title="Conta">
        <ContaSection />
      </SettingsCard>
    </div>
  );
}
